<template>
    <modal @close="editAccountHeaderCancelClick" class="edit-modal" hideFooter id="edit-account-header">
        <div class="td-edit-container one-step">
            <div class="pagination">
                <div class="form-name">
                    <h3>Edit Account</h3>
                    <p>
                        Edit the account name, status or type.
                    </p>
                    <p>
                        You can only change an account from Active to any other status if:
                    </p>
                    <ul>
                        <li>No Active Locations</li>
                        <li>No Active Users</li>
                    </ul>
                    <p>To Purge an account:</p>
                    <ul>
                        <li>No Active Subscriptions</li>
                        <li>Users set to Purge</li>
                        <li>Locations set to Purge</li>
                    </ul>

                </div>
            </div>
            <div class="edit-pages">
                <form>
                    <h3>Edit Account</h3>
                    <div class="md-col-2">
                        <div class="column">

                            <div class="mt-3">
                                <label class="td-label td-text-bold mt-0">Account Name:</label>
                                <input v-model="model.name" type="text" />
                            </div>

                            <div class="mt-3">
                                <label class="td-label td-text-bold mt-0">Account Status:</label>
                                <select v-model="model.status" required>
                                    <option v-for="status in statusList" :value="status" :key="status">{{ getStatusDisplay(status) }}</option>
                                </select>
                            </div>

                            <div class="mt-3">
                                <label class="td-label td-text-bold">Account Type:</label>
                                <select v-model="model.type" required>
                                    <option v-for="type in typeList" :value="type" :key="type">{{ getTypeDisplay(type) }}</option>
                                </select>
                            </div>

                            <div class="mt-3 td-banner danger" v-if="errorMessage.length > 0">
                                <icon name="faTriangleExclamation" type="solid"></icon>
                                <p>{{ errorMessage }}</p>
                            </div>
                        </div>
                        <div class="column">

                        </div>
                    </div>
                </form>

                <div class="actions">
                    <div>
                        <button class="td-btn primary-outlined" @click="editAccountHeaderCancelClick">Cancel</button>
                    </div>
                    <div class="save-btn">
                        <button class="td-btn btn primary" @click="editAccountHeaderSaveClick"><span v-if="isLoading"><icon name="faSpinner" type="solid" spin></icon>&nbsp;</span>Save</button>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
    import script from './EditAccountHeader';
    export default script;
</script>
